/**
 * HA-357 slice C — runs an order's create, then starts the till's read of the server's charge for it WITHOUT waiting on it.
 * The write queue moves on as soon as the create has answered: a line added right after the create is written at once, not
 * behind the read. The read swallows its own errors, and a failed create never starts it.
 */
export async function createThenAdopt(
	create: () => unknown,
	adopt: () => unknown,
): Promise<void> {
	await create();
	void adopt();
}
